import React from 'react';
import { Navigate } from 'react-router-dom';
import { ROUTES } from '../constant/routes';

const GlobalSettingPage = () => {
  return <Navigate replace to={ROUTES.GLOBAL_SETTING.USER_INFO} />;
};

export default GlobalSettingPage;
